import { Icon, ICONS_ENUM, Typography } from '@sanlam-glacier/app-common/components';
import styles from './no-results.module.scss';
import { InstructionCategory, Status } from 'modules/case-tracking/types/filtering/filtering.enums';
import { Stage } from 'modules/case-tracking/types/case-tracking.enums';

type NoResultsProps = {
  categoryFilters: InstructionCategory[];
  stageFilters: Stage[];
  statusFilters: Status[];
  searchTerm: string;
};

const NoResults = ({
  categoryFilters,
  stageFilters,
  statusFilters,
  searchTerm
}: NoResultsProps) => {
  const filterString = (filters: string[]) => {
    return filters.map((item) => `“${item}”`);
  };

  const categoryText = () => {
    return `${filterString(categoryFilters).join(` or `)}`;
  };

  const stageText = () => {
    return `${filterString(stageFilters).join(` or `)}`;
  };

  const statusText = () => {
    return `${filterString(statusFilters).join(` or `)}`;
  };

  const titleText = () => {
    let text = 'You do not have any ';

    if (categoryFilters.length > 0) {
      text += `${categoryText()}`;
    }
    if (statusFilters.length > 0) {
      if (categoryFilters.length > 0) {
        text += ` or `;
      }
      text += `${statusText()}`;
    }
    if (stageFilters.length > 0) {
      if (categoryFilters.length > 0 || statusFilters.length > 0) {
        text += ` or `;
      }
      text += `${stageText()}`;
    }
    text += ' instructions.';
    return text;
  };

  const subtitleText = () => {
    let text = categoryFilters.length > 0 ? 'When a ' : 'When an instruction ';

    if (categoryFilters.length > 0) {
      text += `${categoryText()} instruction has been added`;
    }
    if (stageFilters.length > 0) {
      if (categoryFilters.length > 0) {
        text += `, or `;
      }
      text += `has been allocated to the ${stageText()} stage`;
    }
    if (statusFilters.length > 0) {
      if (categoryFilters.length > 0 || stageFilters.length > 0) {
        text += `, or `;
      }
      text += `has been allocated to the ${statusText()} status`;
    }
    text += `, it will be displayed here.`;
    return text;
  };

  return (
    <>
      {searchTerm ? (
        <div className={styles.container}>
          <Icon className={styles.errorIcon} icon={ICONS_ENUM.ACTION_YOUTUBE_SEARCHED_FOR} />
          <Typography className={styles.searchText} variant={Typography.VARIANT.B2}>
            <div className={styles.textContainer}>
              <div className={styles.searchErrorContainer}>
                We are unable to find a result for
                <Typography
                  className={styles.searchText}
                  weight={Typography.WEIGHT.MEDIUM}
                >{` “${searchTerm}”.`}</Typography>
              </div>
              <br />
              <p>Please try another search.</p>
            </div>
          </Typography>
        </div>
      ) : (
        <div className={styles.container}>
          <div className={styles.errorMessageContainer}>
            <Icon className={styles.errorIcon} icon={ICONS_ENUM.ACTION_INFO} />
            <Typography
              className={styles.errorMessageText}
              variant={Typography.VARIANT.B2}
              weight={Typography.WEIGHT.MEDIUM}
            >
              {titleText()}
            </Typography>
          </div>
          <Typography className={styles.errorMessageText} variant={Typography.VARIANT.B3}>
            {subtitleText()}
          </Typography>
        </div>
      )}
    </>
  );
};

export default NoResults;
